<template>
  <div class="text-center">
    <v-dialog v-model="dialog" width="500">
      <v-card>
        <v-card-title class="text-h5 blue darken-3 white--text">
          Cambiar estado de la inscripcion
        </v-card-title>

        <v-card-text>
          <v-divider></v-divider>
          <v-row>
            <v-col>
              <p>Seleccione un estado:</p>
              <v-radio-group v-model="xestado" class="text-center">
                <v-radio v-for="n in xestados" :key="n.id" :label="n.text" :value="n"></v-radio>
              </v-radio-group>
            </v-col>
            <v-col v-if="$store.state.CARGO.id == 1">
              <p>Cambiar estado(fase) de la inscripcion (solo master)</p>
              <v-radio-group v-model="xestadoins" class="text-center">
                <v-radio v-for="n in xestadosins" :key="n.id" :label="n.text" :value="n"></v-radio>
              </v-radio-group>

              <v-btn color="primary" outlined @click="enviar2()" :disabled="loading">
                Guardar estado Ins
              </v-btn>
            </v-col>
          </v-row>
          <p class="text-center red--text">{{ msg }}</p>
          <v-divider></v-divider>
          <v-progress-linear v-if="loading" indeterminate color="indigo"></v-progress-linear>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" outlined @click="enviar()" :disabled="loading">
            Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import xaxios from '@/xaxios';
  export default {
    data() {
      return {
        dialog: false,
        loading: false,
        // preinscrito/inscrito/cambiado/retirado
        idins: null,
        xestado: null,
        xestadoins: null,
        xestados: [
          { id: 1, text: 'Activo' },
          { id: 0, text: 'Inactivo' },
        ],
        xestadosins: [
          { id: 0, text: 'Pre inscrito' },
          { id: 1, text: 'Inscrito' },
          { id: 2, text: 'Retirado' },
          { id: 3, text: 'Cambiado' },
        ],
        msg: '',
      };
    },
    methods: {
      openmodal(inscripcion) {
        window.console.log(inscripcion);
        let xes = inscripcion.estado_persona ? 1 : 0;
        this.idins = inscripcion.id;
        this.xestadoins = this.xestadosins.find((x) => x.id == inscripcion.estado_ins);
        this.xestado = this.xestados.find((x) => (x.id = xes));
        this.dialog = true;
        this.msg = '';
      },
      enviar() {
        this.msg = '';
        if (!this.xestado) {
          this.msg = 'Selecciona un estado para cambiar.';
          return;
        }

        this.loading = true;
        const vue = this;
        const url = `${process.env.VUE_APP_API_REST}/api/v1/inscripcion/${this.idins}/estado`;
        let data = { estado: this.xestado.id == 0 ? false : true };
        xaxios
          .patch(url, data)
          .then((res) => {
            window.console.log(res);
            vue.msg = res.data.result;
            vue.loading = false;
          })
          .catch((error) => {
            window.console.error(error);
            vue.msg = error;
            vue.loading = false;
          });
      },
      enviar2() {
        this.msg = '';
        if (!this.xestadoins) {
          this.msg = 'Selecciona un estado de inscripcion para cambiar.';
          return;
        }
        if (this.xestadoins.id == 0) {
          this.msg = 'No se puede bajar a pre inscrito, puede optar por hacer liquidacion de cartera.';
          return;
        }

        this.loading = true;
        const vue = this;
        const url = `${process.env.VUE_APP_API_REST}/api/v1/inscripcion/${this.idins}/estado_ins`;
        let data = { estado_ins: this.xestadoins.id };
        xaxios
          .patch(url, data)
          .then((res) => {
            window.console.log(res);
            vue.msg = res.data.data;
            vue.loading = false;
          })
          .catch((error) => {
            window.console.error(error);
            vue.msg = error;
            vue.loading = false;
          });
      },
    },
  };
</script>
